import { render, staticRenderFns } from "./Appliance.vue?vue&type=template&id=37f0dee0"
import script from "./Appliance.vue?vue&type=script&lang=js"
export * from "./Appliance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports